import HeaderProfileSection from 'components/Layout/App/Header/components/HeaderProfileSection'
import { StyledLogo } from 'components/Layout/App/Sidenav/Sidenav.styles'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import React, { useState, useEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as Logo } from 'assets/img/logo-new.svg'
import { ReactComponent as MenuIcon } from 'assets/img/menu-icon.svg'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { connect } from 'react-redux'
import { Site } from 'types/common'
import { useMeasure } from 'react-use'
import { toggleMobileMenu } from 'reducers/layout/reducer'
import FeedbackWidget from 'widgets/Feedback'
import {
  StyledHeader,
  StyledHeaderRightSection,
  StyledHeaderLicenseeLogo,
  StyledMenuButton,
  HeaderGlobalStyles,
} from './Header.styles'
import { HeaderProps, Licensee } from './Header.types'

const Header = ({
  onClick,
  toggleMobileMenu,
  licensee: { logoUrl, name },
  site,
  currentAppName,
  isProfileFetching,
}: HeaderProps) => {
  const [measureRef, { width }] = useMeasure<HTMLDivElement>()
  const licenseeLogo = !logoUrl ? '' : logoUrl
  const logoAlt = `${name} logo`
  const isMobileResolution = ifWindowWidthLessThan(TABLET_BREAKPOINT)

  const menuToggle = () => {
    toggleMobileMenu()
    onClick()
  }

  const [mount, setMount] = useState<{
    logoEl: ShadowRoot
    menuEl: ShadowRoot
  } | null>(null)

  const isJobsApp = useMemo(() => currentAppName === 'Jobs', [currentAppName])

  useEffect(() => {
    const logoEl = document.createElement('div')
    const menuEl = document.createElement('div')

    logoEl.style.width = '24px'
    logoEl.style.height = '24px'
    menuEl.style.width = '24px'
    menuEl.style.height = '24px'

    const attachElApps = document.body.querySelector('.module-head')

    if (isMobileResolution && attachElApps) {
      if (!isJobsApp) {
        attachElApps?.firstElementChild?.append(logoEl)
      }
      attachElApps?.firstElementChild?.prepend(menuEl)

      setMount({
        logoEl: logoEl.attachShadow({ mode: 'open' }),
        menuEl: menuEl.attachShadow({ mode: 'open' }),
      })
    }

    return () => {
      if (attachElApps && isMobileResolution) {
        if (!isJobsApp) {
          attachElApps?.firstElementChild?.removeChild(logoEl)
        }
        attachElApps?.firstElementChild?.removeChild(menuEl)
      }
    }
  }, [
    isProfileFetching,
    isMobileResolution,
    JSON.stringify(site),
    window.location.pathname,
    document.body.querySelector('.module-head'),
  ])

  return (
    <>
      <HeaderGlobalStyles paddingRight={width} />
      <StyledHeader>
        {isMobileResolution && mount && (
          <>
            {!isJobsApp &&
              createPortal(
                <StyledLogo to="/">
                  <Logo />
                </StyledLogo>,
                mount.logoEl,
              )}
            {createPortal(
              <StyledMenuButton
                onClick={menuToggle}
                align="center"
                justify="center">
                <MenuIcon />
              </StyledMenuButton>,
              mount.menuEl,
            )}
          </>
        )}
        {!isMobileResolution && (
          <StyledHeaderRightSection ref={measureRef}>
            {licenseeLogo && (
              <StyledHeaderLicenseeLogo align="center">
                <img src={licenseeLogo} alt={logoAlt} />
              </StyledHeaderLicenseeLogo>
            )}
            <HeaderProfileSection />
            <FeedbackWidget />
          </StyledHeaderRightSection>
        )}
      </StyledHeader>
    </>
  )
}

export default connect(
  (state: {
    getIn: (path: Array<string>) => Licensee | Site | string | boolean
  }) => ({
    licensee: state.getIn(['profile', 'profile', 'licensee']) as Licensee,
    site: state.getIn(['profile', 'profile', 'site']) as Site,
    currentAppName: state.getIn(['profile', 'currentAppName']) as string,
    isProfileFetching: state.getIn(['profile', 'isProfileFetching']) as boolean,
  }),
  {
    toggleMobileMenu,
  },
)(Header)
